import { render, staticRenderFns } from "./ChatRoomItem.vue?vue&type=template&id=24aef729&scoped=true&"
import script from "./ChatRoomItem.vue?vue&type=script&lang=ts&"
export * from "./ChatRoomItem.vue?vue&type=script&lang=ts&"
import style0 from "./ChatRoomItem.vue?vue&type=style&index=0&id=24aef729&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24aef729",
  null
  
)

export default component.exports